import React, { useCallback, useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { useMutation, useQueryClient } from "react-query";
import ModalCancelUploaderImage from "../modals/ModalCancelUploaderImage";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import FolderZipOutlinedIcon from "@mui/icons-material/FolderZipOutlined";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import useDownloader from "react-use-downloader";
import { DocumentUrl } from "../../models/cartable.model";

export default function LoadDocumentComponent(props: any) {
  let fileType;
  let documentTypeTitle;
  if (props.data.fileType == undefined) {
    let type = props.data?.fileData.type.split("/");
    fileType = type[1];
  } else {
    fileType = props.data.fileType;
  }
  if (props.data.documentTypeTitle == undefined) {
    documentTypeTitle = props.data.fileName;
  } else {
    documentTypeTitle = props.data.documentTypeTitle;
  }

  const { download } = useDownloader();
  let typeFiles: any;
  let type;
  if (
    fileType.toLowerCase() == "image" ||
    fileType == "png" ||
    props.data?.fileData.type.toLowerCase().includes("image")
  ) {
    typeFiles = (
      <img
        src={props.data.fileUrl}
        className="uploadImageImg"
        style={{ padding: "1vh", width: "inherit !important" }}
        alt=""
      />
    );
    type = "jpg";
  } else if (fileType == "PDF" || fileType == "pdf") {
    typeFiles = (
      <PictureAsPdfOutlinedIcon
        className="uploadImageIcon jusfityImage"
        style={{ width: "1em", height: "1em" }}
      />
    );
    type = "pdf";
  } else if (
    fileType == "ZIP" ||
    fileType == "RAR" ||
    fileType == "rar" ||
    fileType == "zip"
  ) {
    typeFiles = (
      <FolderZipOutlinedIcon className="uploadImageIcon jusfityImage" />
    );
    type = "RAR";
  } else {
    typeFiles = (
      <InsertDriveFileOutlinedIcon className="uploadImageIcon jusfityImage" />
    );
    type = "jpg";
  }

  if (fileType == null || fileType == undefined) {
    typeFiles = null;
  }
  const fileUrl = props.data.fileUrl;
  const queryClient = useQueryClient();
  const filename = `${type}`;
  const handleDownloda = () => {
    download(fileUrl, filename);
    window.open(fileUrl);
  };
  // const deleteDocument = useMutation(
  //     DeleteAttachmentNotice,
  //     {
  //         onSuccess: (
  //             result: ApiResultModel<boolean>) => {
  //             if (result.isSuccess == true) {
  //                 let noticeAttachment = props.attachment?.filter((item: any) => item.fileId != props.serviceRequestObj.fileId);
  //                 let getFileUrl = noticeAttachment?.map((item: any) => item.fileUrl);
  //                 props.setChildValue(getFileUrl);
  //             }
  //         },
  //         onError: () => { },
  //     });

  const deleteDocument = useMutation(props.serviceName, {
    onSuccess: async (data: boolean) => {
      if (data) {
        if (props.cacheName != undefined) {
          let supplierAttachments = queryClient.getQueryData<DocumentUrl[]>(
            props.cacheName
          );
          supplierAttachments?.map((item: any) => {
            if (item.fileId === props.data.fileId) {
              item.fileUrl = undefined;
              return;
            }
          });
          queryClient.setQueryData(props.cacheName, supplierAttachments);
          props.setChildValue(queryClient.getQueryData(props.cacheName));
        } else if (props.attachments != undefined) {
          let attachmentsTemprory = props.attachments?.filter(
            (x: { fileId: any }) => x.fileId != props.data.fileId
          );
          props.setChildValue(attachmentsTemprory);
        } else {
          props.setChildValue(undefined);
        }
      }
    },
    onError: (err) => {},
  });

  const deleteImage = () => {
    if (props.serviceRequestObj != undefined) {
      deleteDocument.mutate(props.serviceRequestObj);
    } else if (props.multiItem != undefined && props.multiItem) {
      let supplierAttachments = props.attachments?.filter(
        (item: any) => item.fileUrl != props.data.fileUrl
      );

      props.setChildValue(supplierAttachments);
    } else {
      props.setChildValue(undefined);
    }
  };

  const handleOpenImage = () => {
    const imageUrl = `${props.data.fileUrl!}/true`;

    if (!imageUrl) {
      alert("آدرس تصویر وجود ندارد.");
      return;
    }

    const newWindow = window.open("", "_blank");
    if (!newWindow) {
      alert("پنجره جدید توسط مرورگر مسدود شده است.");
      return;
    }

    const htmlContent = `
    <!DOCTYPE html>
    <html lang="fa">
    <head>
      <meta charset="UTF-8">
      <title>نمایش تصویر</title>
      <style>
      @font-face {
      font-family: "iranSansMedium";
      src: url("/fonts/IRANSansBold.ttf");
      }
      html, body {
      height: 100%;
      margin: 0;
      padding: 0;
      }
      body {
      background-color: #fff;
      margin: 0;
      font-family: "iranSansMedium";
      min-height: 100vh;
      min-width: 100vw;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      }
      .image-container {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100vw;
      height: 20vh;
      flex: 1;
      overflow: hidden;
      }
      img {
      max-width: 90vw;
      max-height: 80vh;
      min-width: 40%;
      min-height: 40%;
      transition: transform 0.3s ease, width 0.3s, height 0.3s;
      border: 1px solid #ddd;
      display: block;
      margin: 0 auto;
      object-fit: contain;
      cursor: default;
      }
      img.zoom-cursor {
      cursor: zoom-in;
      }
      img.zoomed {
      cursor: zoom-out;
      z-index: 10;
      }
      .buttons {
      margin-top: 20px;
      position: static;
      text-align: center;
      }
      button {
      height: 5vh;
      background-color: #3498db;
      color: white;
      border: none;
      padding: 7px 20px;
      margin: 0 10px;
      font-size: 15px;
      cursor: pointer;
      border-radius: 5px;
      font-family: "iranSansMedium";
      display: inline-flex;
      align-items: center;
      gap: 5px;
      }
      button .icon {
      font-family: "iranSansMedium";
      font-size: 1.3rem;
      vertical-align: middle;
      position: relative;
      top: 3px;
      }
      button:hover {
      background-color: #2980b9;
      }
      </style>
    </head>
    <body>
      <div class="image-container">
      <img id="rotatableImage" src="${imageUrl}" alt="تصویر" />
      </div>
      <div class="buttons">
      <button onclick="rotate(-90)"><span class="icon">⟲</span> چرخش به چپ</button>
      <button onclick="rotate(90)">چرخش به راست <span class="icon">⟳</span></button>
      </div>
      <script>
      let angle = 0;
      let scale = 1;
      function rotate(deg) {
      angle = (angle + deg) % 360;
      updateTransform();
      // Adaptive resizing for 90/270 degrees
      const img = document.getElementById("rotatableImage");
      if (Math.abs(angle % 180) === 90) {
        img.style.maxWidth = "80vh";
        img.style.maxHeight = "90vw";
      } else {
        img.style.maxWidth = "90vw";
        img.style.maxHeight = "80vh";
      }
      }
      function updateTransform() {
      const img = document.getElementById("rotatableImage");
      img.style.transform = "rotate(" + angle + "deg) scale(" + scale + ")";
      }
      // Initial resize in case image is already rotated
      rotate(0);

      // Zoom on hover/click
      const img = document.getElementById("rotatableImage");
      img.classList.add('zoom-cursor');
      let zoomed = false;
      img.addEventListener('mouseenter', function() {
      img.classList.add('zoom-cursor');
      });
      img.addEventListener('mouseleave', function() {
      img.classList.remove('zoom-cursor');
      img.classList.remove('zoomed');
      scale = 1;
      updateTransform();
      zoomed = false;
      });
      img.addEventListener('click', function() {
      zoomed = !zoomed;
      if (zoomed) {
        scale = 2;
        img.classList.add('zoomed');
      } else {
        scale = 1;
        img.classList.remove('zoomed');
      }
      updateTransform();
      });
      </script>
    </body>
    </html>
    `;

    newWindow.document.open();
    newWindow.document.write(htmlContent);
    newWindow.document.close();
  };
  return (
    <div className="UploadImageCmp">
      {typeFiles ? (
        <span
          onClick={handleDownloda}
          className="uploadImage verticalCenter"
          style={{ width: "inherit !important", height: "80%" }}
        >
          {typeFiles}
        </span>
      ) : (
        <a
          onClick={() => handleOpenImage()}
          href={`${props.data.fileUrl!}/true`}
          target="blank"
        >
          <img
            style={{ padding: "1vh", width: "inherit !important" }}
            src={props.data.fileUrl ? `${props.data.fileUrl}/true` : ""}
            className="uploadImage"
            alt=""
          />
        </a>
      )}
      <Grid
        className="row rowUploadImage"
        container
        xs={12}
        alignItems={"center"}
      >
        <Grid item xs={10}>
          <div
            style={{ color: "#fff", marginRight: "10px", overflow: "hidden" }}
          >
            <p className="paraghramImage infoText">{documentTypeTitle}</p>
          </div>
        </Grid>
        <Grid item xs={2} style={{ paddingBottom: "10px" }}>
          <ModalCancelUploaderImage
            title={""}
            bgColor={"kamanColor"}
            setValue={deleteImage}
          />
        </Grid>
      </Grid>
    </div>
  );
}
